import { render } from "./bankAccount.vue?vue&type=template&id=5a7f0067&scoped=true"
import script from "./bankAccount.vue?vue&type=script&lang=js"
export * from "./bankAccount.vue?vue&type=script&lang=js"

import "./bankAccount.vue?vue&type=style&index=0&id=5a7f0067&lang=scss&scoped=true"

import exportComponent from "/home/lcs/jenkins/workspace/v2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a7f0067"]])

export default __exports__